export class Loading {
    constructor() {
        this.element = document.createElement("div");
        this.element.className = "loading";
        this.element.innerHTML = `<div class="loader"></div>`;
        document.body.appendChild(this.element);
    }

    show() {this.element.classList.remove("hidden");}

    hide() {this.element.classList.add("hidden");}
}